module.exports = __webpack_public_path__ + "static/media/vinnie.4dec82b1.png";